<template>
  <!-- eslint-disable vue/max-attributes-per-line -->
  <v-card class="benefits-toolbar mb-5" flat outlined>
    <v-row dense align="start">
      <!-- Desktop: all filters in one row -->
      <template v-if="!xs || filtersOpen">
        <slot name="prepend" :filters="localFilters" />

        <v-col v-if="showSearch" cols="12" sm="3">
          <v-text-field
            v-model="localFilters.search"
            :label="searchLabel"
            :prepend-inner-icon="mdiMagnify"
            dense
            outlined
            hide-details
            clearable
            @keydown.enter="apply"
          />
        </v-col>

        <v-col v-if="showStatus" cols="12" sm="2">
          <v-select
            v-model="localFilters.status"
            :items="statusItems"
            :label="statusLabel"
            dense
            outlined
            hide-details
            clearable
          />
        </v-col>

        <v-col v-if="showDateRange" cols="12" sm="2">
          <v-menu v-model="menuFrom" :close-on-content-click="false" offset-y>
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="localFilters.date_from"
                :label="dateFromLabel"
                readonly
                clearable
                dense
                outlined
                hide-details
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker v-model="localFilters.date_from" @input="menuFrom = false" />
          </v-menu>
        </v-col>

        <v-col v-if="showDateRange" cols="12" sm="2">
          <v-menu v-model="menuTo" :close-on-content-click="false" offset-y>
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="localFilters.date_to"
                :label="dateToLabel"
                readonly
                clearable
                dense
                outlined
                hide-details
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker v-model="localFilters.date_to" @input="menuTo = false" />
          </v-menu>
        </v-col>

        <slot name="extra-filters" :filters="localFilters" />
      </template>

      <v-col cols="12" md="auto" class="d-flex align-center justify-end ml-md-auto pt-0 pt-md-3" style="gap: 8px;">
        <v-btn
          v-if="xs"
          icon
          small
          class="mr-1"
          :aria-label="filtersOpen ? 'Скрыть фильтры' : 'Показать фильтры'"
          @click="filtersOpen = !filtersOpen"
        >
          <v-icon small>
            {{ mdiTune }}
          </v-icon>
        </v-btn>
        <v-btn
          color="primary"
          small
          :loading="loading"
          class="mr-1"
          @click="apply"
        >
          Применить
        </v-btn>
        <v-btn
          small
          outlined
          @click="reset"
        >
          Сброс
        </v-btn>
        <slot name="actions" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mdiMagnify, mdiTune } from '@mdi/js'

export default {
  name: 'BenefitsToolbar',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    statusItems: {
      type: Array,
      default: () => [],
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
    statusLabel: {
      type: String,
      default: 'Статус',
    },
    showDateRange: {
      type: Boolean,
      default: false,
    },
    searchLabel: {
      type: String,
      default: 'Поиск',
    },
    dateFromLabel: {
      type: String,
      default: 'Дата с',
    },
    dateToLabel: {
      type: String,
      default: 'Дата по',
    },
  },
  data() {
    return {
      mdiMagnify,
      mdiTune,
      menuFrom: false,
      menuTo: false,
      filtersOpen: false,
      localFilters: { ...this.value },
      initialFilters: { ...this.value },
    }
  },
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xs
    },
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.localFilters = { ...val }
      },
    },
  },
  created() {
    this.initialFilters = { ...this.value }
  },
  methods: {
    apply() {
      this.$emit('input', { ...this.localFilters })
      this.$emit('apply', { ...this.localFilters })
    },
    reset() {
      this.localFilters = { ...this.initialFilters }
      this.$emit('input', { ...this.localFilters })
      this.$emit('apply', { ...this.localFilters })
    },
  },
}
</script>

<style scoped>
.benefits-toolbar {
  padding: 16px;
}

@media (min-width: 960px) {
  .benefits-toolbar {
    padding: 20px;
  }
}
</style>
